
define('text!modules/admin/user/templates/createEdit.html',[],function () { return '<div class="w-Admin w-UsersCreateEdit w-CreateEditForm w-box">\n  <div class="w-head create-edit-head">\n    {{>header}}\n  </div>\n  <div class="w-body">\n    {{>body}}\n  </div>\n  {{>footer}}\n</div>\n';});

